import { StringObject } from '@intelliarts/ia-react-template';

import employees from '../../components/Employee/locales/employeesLocale-ua';

const localizationUA: StringObject = {
  template: {
    src: {
      components: {
        layout: {
          header: {
            appName: 'Користувачі'
          }
        },
        dialog: {
          cancelButton: 'Відмінити'
        },
        error: {
          default: {
            defaultErrorMessage: 'Щось пішло не так, спробуйте ще раз'
          }
        }
      },
    },
  },
  /********************************************/
  src: {
    components: {
      pages: {
        notFoundPage: {
          message: 'Перепрошую, ви часом не бачили цю сторінку? \n Ми її здається загубили.. \n' +
            'Якщо побачите - пищіть у #under-the-carpet'
        },
        headcountDashboard: {
          title: 'Дашборд чисельності',
          chooseYear: 'Оберіть рік',
          numbersOnAGlance: 'Цифри одним поглядом',
          noData: 'Немає даних за цей рік.',
          projectsNoData: 'Немає даних за проєктами за цей рік.',
          headcountActiveHint: 'Активні: {{count}}',
          headcountInactiveHint: 'Відпустки: {{count}}',
          employeesPerStatusMath:
            'Разом {{total}} = активні {{active}} + відпустки {{inactive}}.',
          loadError: 'Не вдалося завантажити дані чисельності. Спробуйте ще раз.',
          retry: 'Повторити',
          yearlyTrendUnavailable:
            'Річний тренд чисельності недоступний від сервера в цьому середовищі.',
          newComersHint: 'Приєдналися протягом {{year}}',
          newComersShareOfHeadcount: '{{percent}}% від загальної чисельності',
          benchShareOfActive: '{{percent}}% від активних співробітників',
          benchHint: 'Очікують на призначення',
          benchNoDataBefore: 'Бенч не відстежувався до {{year}}',
          vsPreviousYear: '{{delta}} порівняно з {{year}}',
          vsPreviousMonth: '{{delta}} порівняно з {{month}}',
          deltaAbsolute: '{{value}}',
          deltaTenureYears: '{{value}} р.',
          widgets: {
            headcount: 'Чисельність',
            employeesPerStatus: 'За статусом',
            averageTenure: 'Середній стаж',
            newComers: 'Новачки',
            onBench: 'На бенчі',
            headcountGrowth: 'Зростання',
            headcountByGender: 'За статтю',
            headcountByLocation: 'За локацією',
            headcountByTenure: 'За стажем',
            headcountMom: 'Помісячно',
            headcountByProjects: 'За проєктами',
          },
          stats: {
            projects: 'Проєкти',
            biggestProject: 'Людей на найбільшому проєкті ({{name}})',
            subProjects: 'Людей на підпроєктах {{group}} ({{count}})',
          },
          sort: {
            label: 'Сортувати проєкти',
            byName: 'За назвою',
            byPeople: 'За кількістю',
          },
          groups: {
            label: 'Групи проєктів',
            expand: 'Розгорнути {{group}}',
            collapse: 'Згорнути {{group}}',
          },
          generalHc: {
            active: 'Активні',
            maternity: 'Декрет',
            military: 'Військова служба',
            sabbatical: 'Сабатикал',
          },
          yoy: {
            avgHc: 'Середня чисельність',
            selectedYear: 'Обраний рік',
            growthPercent: 'Зростання р/р (%)',
          },
          mom: {
            segmentActive: 'Активні',
            segmentAllocated: 'Призначені',
            segmentBench: 'Бенч',
            segmentInactive: 'Відпустки',
            futureMonths: 'Майбутні місяці',
          },
          projects: {
            other: 'Інші проєкти',
            hubSpot: 'HubSpot',
          },
          breakdown: {
            male: 'Чоловіки',
            female: 'Жінки',
            lviv: 'Львів',
            ukraineRemote: 'Віддалено (Україна)',
            abroad: 'За кордоном',
            tenureLt2: '<2 роки',
            tenure2to5: '2–5 років',
            tenure5to10: '5–10 років',
            tenureGt10: '10+ років',
            headcount: 'Чисельність',
          },
          tenureYearsShort: '{{years}} р.',
        },
        turnoverDashboard: {
          title: 'Дашборд плинності',
          chooseYear: 'Оберіть рік',
          numbersOnAGlance: 'Цифри одним поглядом',
          noData: 'Немає даних плинності за цей рік.',
          noLeavers: 'Протягом обраного року ніхто не пішов.',
          noVoluntaryExits: 'Добровільних звільнень цього року не було.',
          noInvoluntaryExits: 'Недобровільних звільнень цього року не було.',
          loadError: 'Не вдалося завантажити дані плинності. Спробуйте ще раз.',
          retry: 'Повторити',
          monthlyTurnoverHint: 'Поточний місяць: {{month}}',
          turnoverRateHint: '{{count}} співробітників залишили компанію протягом обраного року',
          probationFailureHint: '{{count}} невдалих випробувальних термінів',
          newHireTurnoverHint: '{{count}} нових співробітників пішли протягом першого року',
          retentionHint: 'Початок: {{start}}, кінець: {{end}}',
          vsPreviousPeriod: '{{delta}} порівняно з {{period}}',
          deltaPp: '{{value}} в.п.',
          projectsHint: 'Підпис: рівень% (скільки людей пішло); колір поділяє його за типом звільнення. Малі команди (≤3) показано окремо.',
          projectsNoDataForYear: 'У {{year}} році призначення на проєкти не фіксувалися, тому плинність неможливо розподілити за проєктами. Дані за проєктами починаються з 2026 року.',
          projectsChartedSeparately: 'Усі проєктні звільнення у {{year}} році були в малих командах — див. «Малі команди» поруч із цим графіком.',
          widgets: {
            monthlyTurnoverRate: 'Плинність за місяць',
            yearlyTurnoverRate: 'Плинність за рік',
            probationFailureRate: 'Невдалі випробувальні терміни',
            newHireTurnoverRate: 'Плинність нових співробітників',
            retentionRate: 'Рівень утримання',
            turnoverVoluntaryVsInvoluntary: 'Добровільна та недобровільна',
            turnoverVoluntaryReasons: 'Причини добровільної',
            turnoverInvoluntaryReasons: 'Причини недобровільної',
            turnoverByProjects: 'Плинність за проєктами',
            turnoverInSmallTeams: 'Малі команди',
            turnoverRateComparison: 'Рівні плинності',
          },
          rates: {
            axisHint: 'Стовпчики: рівень плинності (% від середньої чисельності, ліва вісь). Блакитна лінія: люди, що пішли (права вісь).',
            viewLabel: 'Період',
            monthly: 'За місяцями',
            yearly: 'За роками',
            rateAxis: 'Рівень плинності',
            exitsAxis: 'Люди, що пішли',
            total: 'Загальна',
            voluntary: 'Добровільна',
            involuntary: 'Недобровільна',
            exits: 'Люди, що пішли',
            ytdYear: '{{year}} (з початку року)',
            tooltip: '{{rate}} — {{count}} з {{headcount}} людей',
            unclassifiedInYear: 'У {{count}} з {{total}} співробітників, що пішли у {{year}} році, немає типу зміни — добровільна + недобровільна менші за загальну.',
            unclassifiedSince: 'У {{count}} з {{total}} співробітників, що пішли з {{from}} року, немає типу зміни — добровільна + недобровільна менші за загальну.',
          },
          breakdown: {
            voluntary: 'Добровільна',
            involuntary: 'Недобровільна',
            notSpecified: 'Не вказано',
          },
          projects: {
            employeesWhoLeft: 'Люди, що пішли',
            turnoverRate: 'Рівень плинності',
            tooltip: '{{rate}} — {{left}} з {{headcount}} людей',
            groupsLabel: 'Групи проєктів',
            expandGroup: 'Розгорнути {{group}}',
            collapseGroup: 'Згорнути {{group}}',
            quietProjects: 'Ще {{count}} проєктів нікого не втратили у {{year}} році',
            groupBreakdown: 'Показано {{shown}} з {{count}} підпроєктів {{group}} ({{headcount}} людей). Натисніть на стовпчик, щоб згорнути.',
            smallTeamsHint: 'Стовпчики: скільки людей пішло (не рівні), поділені за типом звільнення. Команди ≤3 занадто малі для надійних відсотків.',
            smallTeamLabel: '{{left}} з {{size}}',
            smallTeamTooltip: '{{left}} з {{size}} людей',
          },
        },
      },
      employees,
    },
    /********************************************/
    config: {
      routesConfigs: {
        notFoundPageConfig: {
          name: 'Їжачооок, ти де?'
        },
        headcountPageConfig: {
          name: 'Дашборд чисельності',
          label: 'Дашборд чисельності'
        },
        turnoverPageConfig: {
          name: 'Дашборд плинності',
          label: 'Дашборд плинності'
        },
      },
    },
    /********************************************/
  }
};

export default localizationUA;
